var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";
import { Get, GetFile, Post, Put } from "../api/api";
import { Config } from "../api/config";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { getLocalStorageItem } from "../utils/storageHelper";
import { GoogleAnlyticsErrorLog, handleServerSideErrors, handleServerSideErrorsForAnalytics } from "../utils/utils";
import { showLoader, showNotification } from "./commonSlice";
import { initialState } from './crud.entity';
var BASE_URL = Config.baseURL;
var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
export var createAPI = createAsyncThunk("crud/create", function (_ref, _ref2) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, dispatch, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref.key, url = _ref.url, request = _ref.request;
                dispatch = _ref2.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Post("".concat(url), request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 201 || (response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    return [2 /*return*/, key ? {
                            key: key,
                            value: response
                        } : response];
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    return [2 /*return*/, key ? {
                            key: key,
                            value: response.data
                        } : response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(error_1, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(error_1, url, request), request, error_1 === null || error_1 === void 0 ? void 0 : error_1.trace);
                return [2 /*return*/, {
                        key: key,
                        value: error_1
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getListAPI = createAsyncThunk("crud/getList", function (_ref3, _ref4) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, notShowNotification, dispatch, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref3.key, url = _ref3.url, request = _ref3.request, notShowNotification = _ref3.notShowNotification;
                dispatch = _ref4.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Post("".concat(url), request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    return [2 /*return*/, {
                            key: key,
                            value: response
                        }];
                }
                else if (response === undefined) {
                    return [2 /*return*/, {
                            key: key,
                            value: []
                        }];
                }
                else {
                    if (!notShowNotification) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                            type: "error"
                        }));
                        GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    }
                    return [2 /*return*/, {
                            key: key,
                            value: response === null || response === void 0 ? void 0 : response.data
                        }];
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                if (!notShowNotification) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(e_1, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_1, url, request), request, e_1 === null || e_1 === void 0 ? void 0 : e_1.trace);
                }
                return [2 /*return*/, {
                        key: key,
                        value: e_1
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getByIdAPI = createAsyncThunk("crud/getById", function (_ref5, _ref6) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, dispatch, response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref5.key, url = _ref5.url, request = _ref5.request;
                dispatch = _ref6.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Get("".concat(url), {
                        params: request
                    })];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: response
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                else if (response === undefined) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: []
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: []
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                return [3 /*break*/, 4];
            case 3:
                e_2 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(e_2, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_2, url, request), request, e_2 === null || e_2 === void 0 ? void 0 : e_2.trace);
                if (key) {
                    return [2 /*return*/, {
                            key: key,
                            value: e_2
                        }];
                }
                else {
                    return [2 /*return*/, e_2];
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getPagingAPI = createAsyncThunk("crud/paging", function (_ref7, _ref8) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, params, dispatch, response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref7.key, url = _ref7.url, params = _ref7.params;
                dispatch = _ref8.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Get("".concat(url), {
                        params: _objectSpread({}, params)
                    })];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: response
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                else if (response === undefined) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, params),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, params), params, response === null || response === void 0 ? void 0 : response.trace);
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: []
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, params),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, params), params, response === null || response === void 0 ? void 0 : response.trace);
                    if (key) {
                        return [2 /*return*/, {
                                key: key,
                                value: []
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                return [3 /*break*/, 4];
            case 3:
                e_3 = _a.sent();
                if (key) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(e_3, url, params),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_3, url, params), params, e_3 === null || e_3 === void 0 ? void 0 : e_3.trace);
                    return [2 /*return*/, {
                            key: key,
                            value: e_3
                        }];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(e_3, url, params),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_3, url, params), params, e_3 === null || e_3 === void 0 ? void 0 : e_3.trace);
                    return [2 /*return*/, e_3];
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var updateAPI = createAsyncThunk("crud/update", function (_ref9, _ref10) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, dispatch, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref9.key, url = _ref9.url, request = _ref9.request;
                dispatch = _ref10.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Put("".concat(url), request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    // if (key) return { key, value: response }
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    // if (key) return { key, value: response }
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(error_2, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(error_2, url, request), request, error_2 === null || error_2 === void 0 ? void 0 : error_2.trace);
                if (key) {
                    return [2 /*return*/, {
                            key: key,
                            value: error_2
                        }];
                }
                return [2 /*return*/, error_2];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var deleteAPI = createAsyncThunk("crud/delete", function (_ref11, _ref12) { return __awaiter(void 0, void 0, void 0, function () {
    var url, request, dispatch, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = _ref11.url, request = _ref11.request;
                dispatch = _ref12.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Put("".concat(url), request)];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || (response === null || response === void 0 ? void 0 : response.statusCode) === 201) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Deleted successfully"),
                        type: "success"
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(error_3, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(error_3, url, request), request, error_3 === null || error_3 === void 0 ? void 0 : error_3.trace);
                return [2 /*return*/, error_3];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var uploadAttachmentAPI = createAsyncThunk("crud/upload", function (_ref13, _ref14) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, dispatch, formData, response, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref13.key, url = _ref13.url, request = _ref13.request;
                dispatch = _ref14.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                formData = new FormData();
                formData.append("data", request === null || request === void 0 ? void 0 : request.data);
                return [4 /*yield*/, Post(url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            systemname: request === null || request === void 0 ? void 0 : request.systemname
                        }
                    })];
            case 2:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 201 || (response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    if (key !== "") {
                        return [2 /*return*/, {
                                key: key,
                                value: response
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                else {
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.data, url, request),
                        type: "error"
                    }));
                    GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(response === null || response === void 0 ? void 0 : response.data, url, request), request, response === null || response === void 0 ? void 0 : response.trace);
                    if (key !== "") {
                        return [2 /*return*/, {
                                key: key,
                                value: response
                            }];
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(e_4, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_4, url, request), request, e_4 === null || e_4 === void 0 ? void 0 : e_4.trace);
                if (key !== "") {
                    return [2 /*return*/, {
                            key: key,
                            value: e_4 === null || e_4 === void 0 ? void 0 : e_4.response
                        }];
                }
                else {
                    return [2 /*return*/, e_4];
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getFileAPI = createAsyncThunk("crud/getFile", function (_ref15, _ref16) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, request, headers, dispatch, response, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref15.key, url = _ref15.url, request = _ref15.request, headers = _ref15.headers;
                dispatch = _ref16.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, GetFile(url, {
                        responseType: "blob",
                        params: _objectSpread({}, request),
                        headers: _objectSpread({
                            "Content-Type": "application/octet-stream"
                        }, headers)
                    })];
            case 2:
                response = _a.sent();
                if (key !== "") {
                    return [2 /*return*/, {
                            key: key,
                            value: response
                        }];
                }
                else {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                e_5 = _a.sent();
                dispatch(showNotification({
                    isOpen: true,
                    message: handleServerSideErrors(e_5, url, request),
                    type: "error"
                }));
                GoogleAnlyticsErrorLog(profileData, url, handleServerSideErrorsForAnalytics(e_5, url, request), request, e_5 === null || e_5 === void 0 ? void 0 : e_5.trace);
                if (key !== "") {
                    return [2 /*return*/, {
                            key: key,
                            value: e_5
                        }];
                }
                else {
                    return [2 /*return*/, e_5];
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var crudSlice = createSlice({
    name: "Crud",
    initialState: initialState,
    reducers: {
        setState: function (state, action) {
            var _a;
            var _b = action.payload, key = _b.key, value = _b.value;
            return _objectSpread(_objectSpread({}, state), {}, (_a = {},
                _a[key] = value,
                _a));
        },
        // resetState: (state, action) => {
        //     const keysToReset = action.payload;
        //     keysToReset.forEach((key: string) => {
        //         state[key] = initialState[key];
        //     });
        // },
        resetState: function (state, action) {
            var keysToReset = action.payload;
            keysToReset.forEach(function (key) {
                if (key in initialState) {
                    state[key] = initialState[key]; // Safely reset to initial state
                }
                else {
                    state[key] = initialState[key];
                    console.warn("Key \"".concat(key, "\" not found in initialState"));
                }
            });
        },
        resetAfterLogOutCrud: function () { return initialState; },
        setReducerState: function (state, action) {
            var _a = action.payload, key = _a.key, value = _a.value;
            state[key] = value;
        },
        deleteState: function (state, action) {
            var key = action.payload.key;
            delete state[key];
        },
        pushToArray: function (state, action) {
            var _a;
            var _state$key;
            var _b = action.payload, key = _b.key, value = _b.value;
            if (!((_state$key = state[key]) !== null && _state$key !== void 0 && _state$key.data))
                state[key] = _objectSpread(_objectSpread({}, state[key]), {}, {
                    data: []
                });
            (_a = state[key].data).push.apply(_a, value);
        }
    },
    extraReducers: function (builder) {
        builder.addCase(createAPI.pending, function (state, action) {
            var _action$meta;
            var key = (action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.arg).key;
            if (key)
                state["isLoading".concat(key)] = "loading";
        }).addCase(createAPI.fulfilled, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "idle";
            state[key] = value;
        }).addCase(createAPI.rejected, function (state, action) {
            var key = (action === null || action === void 0 ? void 0 : action.payload).key;
            if (key)
                state["isLoading".concat(key)] = "failed";
        }).addCase(getListAPI.pending, function (state, action) {
            var _action$meta2;
            var key = (action === null || action === void 0 || (_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.arg).key;
            state["isLoading".concat(key)] = "loading";
        }).addCase(getListAPI.fulfilled, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "idle";
            state[key] = value;
        }).addCase(getListAPI.rejected, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "failed";
            state[key] = [];
        }).addCase(getByIdAPI.pending, function (state, action) {
            var _action$meta3;
            var key = (action === null || action === void 0 || (_action$meta3 = action.meta) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.arg).key;
            state["isLoading".concat(key)] = "loading";
        }).addCase(getByIdAPI.fulfilled, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "idle";
            state[key] = value;
        }).addCase(getByIdAPI.rejected, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "failed";
            state[key] = [];
        }).addCase(getPagingAPI.pending, function (state, action) {
            var _action$meta4;
            var key = (action === null || action === void 0 || (_action$meta4 = action.meta) === null || _action$meta4 === void 0 ? void 0 : _action$meta4.arg).key;
            state["isLoading".concat(key)] = "loading";
        }).addCase(getPagingAPI.fulfilled, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "idle";
            state[key] = value;
        }).addCase(getPagingAPI.rejected, function (state, action) {
            var _a = action === null || action === void 0 ? void 0 : action.payload, key = _a.key, value = _a.value;
            state["isLoading".concat(key)] = "failed";
            state[key] = [];
        }).addCase(updateAPI.pending, function (state, action) {
            var _action$meta5;
            var key = (action === null || action === void 0 || (_action$meta5 = action.meta) === null || _action$meta5 === void 0 ? void 0 : _action$meta5.arg).key;
            state["isLoading".concat(key)] = "loading";
        }).addCase(updateAPI.fulfilled, function (state, action) {
            var _action$meta6;
            var key = (action === null || action === void 0 || (_action$meta6 = action.meta) === null || _action$meta6 === void 0 ? void 0 : _action$meta6.arg).key;
            state["isLoading".concat(key)] = "idle";
        }).addCase(updateAPI.rejected, function (state, action) {
            var _action$meta7;
            var key = (action === null || action === void 0 || (_action$meta7 = action.meta) === null || _action$meta7 === void 0 ? void 0 : _action$meta7.arg).key;
            state["isLoading".concat(key)] = "failed";
        }).addCase(deleteAPI.pending, function (state, action) {
            var _action$meta8;
            var key = (action === null || action === void 0 || (_action$meta8 = action.meta) === null || _action$meta8 === void 0 ? void 0 : _action$meta8.arg).key;
            state["isLoading".concat(key)] = "loading";
        }).addCase(deleteAPI.fulfilled, function (state, action) {
            var _action$meta9;
            var key = (action === null || action === void 0 || (_action$meta9 = action.meta) === null || _action$meta9 === void 0 ? void 0 : _action$meta9.arg).key;
            state["isLoading".concat(key)] = "idle";
        }).addCase(deleteAPI.rejected, function (state, action) {
            var _action$meta10;
            var key = (action === null || action === void 0 || (_action$meta10 = action.meta) === null || _action$meta10 === void 0 ? void 0 : _action$meta10.arg).key;
            state["isLoading".concat(key)] = "failed";
        });
    }
});
export var setState = (_a = crudSlice.actions, _a.setState), resetState = _a.resetState, resetAfterLogOutCrud = _a.resetAfterLogOutCrud, setReducerState = _a.setReducerState, deleteState = _a.deleteState, pushToArray = _a.pushToArray;
var crudReducer = crudSlice.reducer;
export default crudReducer;
